// @TODO: Rename this library

import appConfig from 'Config';
import { I13N_CATEGORY_APP, I13N_TYPE_EXCEPTION } from 'Lib/constants/i13nSpec';
import getI13nUtils from 'Lib/i13n/getI13nUtils';
import { localStorage } from 'Lib/storage';
import isExpired from 'Lib/utils/isExpired';
import isUndefined from 'Lib/utils/isUndefined';

const { executeEvent } = getI13nUtils();

const KEY_SESSION_PARAMS = 'sessionParams';
const KEY_SESSION_TIMESTAMP = 'sessionTimestamp';

type SessionParamsType = {
  params?: any;
  timestamp?: number;
};

export const getSearchParams = (searchQuery: string) => {
  if (!searchQuery) {
    return null;
  }
  return new URLSearchParams(searchQuery);
};

const getSessionSearchParams = (allowlist: string[] = []) => {
  const params = __CLIENT__ ? getSearchParams(window.location.search) : null;

  if (params) {
    const filteredParams = {};

    allowlist.forEach((allowedKey: string) => {
      const value = params.get(allowedKey);
      if (!isUndefined(value)) {
        filteredParams[allowedKey] = value;
      }
    });

    return Object.keys(filteredParams).length ? filteredParams : null;
  }

  return null;
};

const defaultSetFunction = (params: any, timestamp: number | string) => {
  localStorage.setItem(KEY_SESSION_PARAMS, JSON.stringify(params));
  localStorage.setItem(KEY_SESSION_TIMESTAMP, `${timestamp}`);
};

const defaultClearFunction = () => {
  localStorage.removeItem(KEY_SESSION_PARAMS);
  localStorage.removeItem(KEY_SESSION_TIMESTAMP);
};

const defaultGetParamsFunction = (): SessionParamsType => {
  let sessionParams = {};
  const params = localStorage.getItem('sessionParams');
  const timestamp = localStorage.getItem('sessionTimestamp') ?? '';

  if (!params) {
    return sessionParams;
  }

  try {
    const json = JSON.parse(params);
    sessionParams = {
      params: json,
      timestamp: +timestamp, // cast back to number
    };
  } catch (e) {
    const eventParams = {
      category: I13N_CATEGORY_APP,
      label: 'Session',
      message: 'Error retrieving and parsing sessionParams',
    };
    executeEvent(I13N_TYPE_EXCEPTION, eventParams);
  }

  return sessionParams;
};

class Session {
  constructor() {
    this.setFunction = defaultSetFunction;
    this.clearFunction = defaultClearFunction;
    this.getParamsFunction = defaultGetParamsFunction;
    this.options = {
      ttl: appConfig.session?.ttl,
      params: appConfig.session?.params,
    };
  }
  setFunction: (b: any, a: string | number) => void;
  getParamsFunction: () => SessionParamsType;
  clearFunction: VoidFunction;
  options: {
    ttl: number;
    params: string[];
  };

  init = () => {
    this.start();
  };

  start = () => {
    const params = getSessionSearchParams(this.options?.params);
    if (params) {
      this.setFunction(params, Date.now());
    }
  };

  clear = () => {
    this.clearFunction();
  };

  getParams = () => {
    const { params, timestamp } = this.getParamsFunction();

    if (params) {
      if (timestamp && !isExpired(timestamp, this.options?.ttl)) {
        return params;
      }
    }
    return {};
  };
}

export default new Session();
